import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed, startLoading, stopLoading } from "store/user-slice";
import Swal from "sweetalert2";
import { RetailerDTO } from "utils/helpers/models/retailer.dto";

interface Filters {
  name?: string;
  mobileNumber?: string;
  companyName?: string;
  status?: string | boolean;
}

export default function useRetailers() {
  const postRetailer = async (body: any) => {
    await Apis.postRetailer(body)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Ingredient"));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getRetailers = async (
    setRetailersData: React.Dispatch<React.SetStateAction<any[]>>,
    filters: Filters & { limit?: number; offset?: number },
    setRetailerPaginationState: Function
  ) => {
    const queryParams = new URLSearchParams(
      filters as Record<string, string>
    ).toString();
    Apis.getRetailers(queryParams)
      .then((res) => {
        setRetailersData(res.data.data);
        setRetailerPaginationState(res.data.pagination);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => dispatch(stopLoading()));
  };
  // const updateRetailer = async (   
  //   retailerId:any,body :any
  // ) => {
  //   const queryParams = new URLSearchParams(
      
  //   ).toString();
  //   Apis.updateRetailer(retailerId,body)
  //     .then((res) => {
  //       return res.data.retailer;
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     })
  //     .finally(() => dispatch(stopLoading()));
  // };
  const updateRetailer = async (retailerId: any, body: any) => {
  dispatch(startLoading());
  return Apis.updateRetailer(retailerId, body)
    .then((res) => {
      console.log(res);
      
      // Update ke baad listing dubara fetch karo
      // getRetailers(); // <-- yahan tumhara listing fetch function call hoga
      return res.data.retailer;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => dispatch(stopLoading()));
};


  const updateUserStatusById = async (userId: string, status: boolean) => {
    try {
      const res = await Apis.putUsers(userId, { status });
      if (res.data.status) {
        console.error(
          "User status updated successfully:",
          res.data.updatedUser
        );
      }
    } catch (err) {
      console.error("Error updating user status:", err);
      throw err;
    }
  };

  const getStates = (): Promise<Response> => {
    return fetch("assets/data/states.json"); // Return the fetch promise directly
  };

  return {
    postRetailer,
    getRetailers,
    updateUserStatusById,
    getStates,
    updateRetailer
  };
}
